export const SITE_MEDIA = {
  // Hero/General
  heroVideo: 'https://customer-assets.emergentagent.com/job_episplain-learn/artifacts/vifaiz5r_7423713-uhd_2160_3840_30fps.mp4',
  heroPoster: 'https://images.unsplash.com/photo-1758691462413-b07dee2933fe?w=1200&q=80',
  
  // Vaccine Images - Updated with needle close-up for hero
  vaccineNeedle: 'https://images.unsplash.com/photo-1647853042468-a152e59ab9b2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHx2YWNjaW5lJTIwbmVlZGxlfGVufDB8fHxibHVlfDE3NzUwMDY3OTF8MA&ixlib=rb-4.1.0&q=85',
  vaccineAdmin: 'https://images.pexels.com/photos/5207034/pexels-photo-5207034.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  vaccine: '/images/vaccines/pexels-gustavo-fring-7446988.jpg',
  vaccineAlt1: '/images/vaccines/pexels-thirdman-5921840.jpg',
  vaccineAlt2: '/images/vaccines/pexels-gustavo-fring-8770695.jpg',
  vaccineAlt3: '/images/vaccines/pexels-gustavo-fring-8770697.jpg',
  
  // Chronic Disease Images - Updated with professional health data images
  chronic: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&q=80',
  chronicAlt1: 'https://images.unsplash.com/photo-1579684385127-1ef15d508118?w=800&q=80',
  chronicAlt2: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&q=80',
  chronicMonitor: 'https://images.pexels.com/photos/5721676/pexels-photo-5721676.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  
  // Autoimmune/Research
  autoimmune: 'https://images.pexels.com/photos/7722791/pexels-photo-7722791.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  
  // Education/Research
  education: 'https://images.unsplash.com/photo-1532938911079-1b06ac7ceec7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwzfHxwdWJsaWMlMjBoZWFsdGh8ZW58MHx8fHwxNzc0NTY5MjAwfDA&ixlib=rb-4.1.0&q=85',
  research: 'https://images.pexels.com/photos/7723401/pexels-photo-7723401.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  
  // Prevention/Wellness
  prevention: 'https://images.unsplash.com/photo-1452626038306-9aae5e071dd3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxwdWJsaWMlMjBoZWFsdGh8ZW58MHx8fHwxNzc0NTY3OTA3fDA&ixlib=rb-4.1.0&q=85',
  
  // Data/Analytics
  dataAnalytics: 'https://images.pexels.com/photos/3970331/pexels-photo-3970331.jpeg?auto=compress&w=800',
  
  // Epidemiology specific
  surveillance: 'https://images.unsplash.com/photo-1576086213369-97a306d36557?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHw0fHxtZWRpY2FsJTIwcmVzZWFyY2h8ZW58MHx8fHwxNzc0NTY3OTEyfDA&ixlib=rb-4.1.0&q=85',
  outbreak: 'https://images.unsplash.com/photo-1578307985320-34b61a66c195?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHw0fHxwdWJsaWMlMjBoZWFsdGh8ZW58MHx8fHwxNzc0NTY5MjAwfDA&ixlib=rb-4.1.0&q=85',
};

// Image galleries for different sections - FULL IMAGES (object-contain)
export const CHRONIC_GALLERY = [
  { src: 'https://images.unsplash.com/photo-1578496480240-32d3e0c04525?w=800', alt: 'Medical research lab', caption: 'Research helps us understand chronic disease patterns' },
  { src: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800', alt: 'Health data analytics', caption: 'Data analysis reveals population health trends' },
  { src: 'https://images.pexels.com/photos/8900018/pexels-photo-8900018.jpeg?w=800', alt: 'Health monitoring', caption: 'Regular monitoring helps detect conditions early' },
];

export const VACCINE_GALLERY = [
  { src: 'https://images.unsplash.com/photo-1647853042468-a152e59ab9b2?crop=entropy&cs=srgb&fm=jpg&w=800&q=85', alt: 'Vaccine needle', caption: 'Vaccines use proven science to protect against disease' },
  { src: 'https://images.pexels.com/photos/5207034/pexels-photo-5207034.jpeg?auto=compress&cs=tinysrgb&w=800', alt: 'Healthcare worker vaccinating', caption: 'Healthcare workers lead vaccination efforts' },
  { src: '/images/vaccines/pexels-gustavo-fring-8770695.jpg', alt: 'Pediatric vaccination', caption: 'Childhood vaccines prevent serious diseases' },
  { src: '/images/vaccines/pexels-gustavo-fring-8770697.jpg', alt: 'Family health', caption: 'Vaccination protects entire families' },
];
